'use client';

import Script from 'next/script';

import { useGtmContainerWithLocale } from '../../hooks';

const optimizelyProjectID = process.env.NEXT_PUBLIC_OPTIMIZELY_PROJECT_ID;

export function OptimizelyScript() {
    const { gtmContainerId } = useGtmContainerWithLocale();

    // Need GTM to load Optimizely
    return optimizelyProjectID && gtmContainerId ? (
        // eslint-disable-next-line @next/next/no-before-interactive-script-outside-document -- This is a script should be loaded in the head
        <Script
            id="optimizely-script"
            strategy="beforeInteractive"
            src={`https://cdn.optimizely.com/js/${optimizelyProjectID}.js`}
        />
    ) : null;
}
